// Central content + config for Abode of Sri Tatva
export const CONFIG = {
  brand: "Abode of Sri Tatva",
  founder: "Shreya",
  tagline: "Spiritual Practitioner & Mentor",
  whatsapp: "917878256171", // real WhatsApp number
  email: "ssinghdhabai@gmail.com",
  instagram: "https://www.instagram.com/healingsbysri",
  instagramHandle: "@healingsbysri",
};

export const waLink = (msg = "Namaste Shreya, I'd love to ask about a session.") =>
  `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(msg)}`;

export const NAV = [
  { label: "About", href: "#about" },
  { label: "Courses", href: "#courses" },
  { label: "Offerings", href: "#offerings" },
  { label: "Reviews", href: "#reviews" },
  { label: "Instagram", href: CONFIG.instagram, external: true },
];

// "Choose the Guidance You Need Right Now" — mirrors reference #guidance-sessions.
// Each card: large image + title + description + bullets + book button.
// TODO(Shreya): replace each `img` with your own photo when ready.
export const GUIDANCE = [
  {
    id: "career",
    kicker: "01 · Career",
    title: "Career Clarity & Professional Direction",
    desc: "For professionals facing career shifts, burnout, job uncertainty, purpose confusion, or the feeling that they have outgrown their current path.",
    points: [
      "Career energy and timing guidance",
      "Strengths and professional direction",
      "Career transition reflection",
      "Practical next steps for the coming months",
    ],
    cta: "Book Career Session",
    img: "/guidance-tarot.jpg",
  },
  {
    id: "love",
    kicker: "02 · Love",
    title: "Marriage, Love & Relationship Guidance",
    desc: "For people navigating relationship patterns, emotional distance, marriage decisions, compatibility concerns, or confusion in love.",
    points: [
      "Relationship pattern reflection",
      "Marriage and commitment guidance",
      "Emotional blocks and repeating cycles",
      "Support for making grounded decisions",
    ],
    cta: "Book Relationship Session",
    img: "/guidance-relationship2.jpg",
  },
  {
    id: "transition",
    kicker: "03 · Healing",
    title: "Life Transition & Emotional Healing",
    desc: "For people going through a breakup, relocation, marriage decision, career pivot, identity shift, family pressure, or a major emotional transition.",
    points: [
      "Emotional grounding and spiritual reflection",
      "Tarot and astrology-based insight",
      "Meditation or energy-clearing guidance",
      "Structured next steps to move forward",
    ],
    cta: "Book Transition Session",
    img: "https://images.pexels.com/photos/5240734/pexels-photo-5240734.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=940",
  },
];

export const OFFERINGS = [
  {
    id: 1,
    title: "Tarot Reading — Deep Dive",
    duration: "60 Min",
    price: "₹2,500",
    img: "/offering-tarot1.jpg",
  },
  {
    id: 2,
    title: "Tarot Reading — Quick Guidance",
    duration: "30 Min",
    price: "₹1,500",
    img: "/offering-tarot2.jpg",
  },
  {
    id: 3,
    title: "Meditative & Healing Session",
    duration: "30 Min",
    price: "₹5,100",
    img: "/offering-healing.jpg",
  },
];

// Courses — flagship teaching programmes. `price: "Enquire"` where price is on request.
export const COURSES = [
  {
    id: "tarot",
    title: "Tarot — Basic to Advance",
    duration: "2.5 Months",
    price: "Enquire",
    exclusive: true,
    img: "/course-tarot.jpg",
    desc:
      "Learn to read Tarot with Shreya over 2.5 months. Any question an individual brings can be explored through the cards — but a true reader must be deeply intuitive. This course builds that intuition, with meditation techniques woven throughout to sharpen your inner knowing.",
    points: [
      "Guided personally by Shreya",
      "Intuition-building practices",
      "Meditation techniques included",
      "Read for any question an individual brings",
    ],
  },
  {
    id: "shrividya",
    title: "Explore Sri Vidhya",
    duration: "3 Months · Exclusive Batch",
    price: "Enquire",
    exclusive: true,
    img: "/course-shrividhya.jpg",
    desc:
      "An exclusive, in-depth immersion into the complete foundation of Sri Vidhya. We study the different lineages and go deep into the sacred texts — all explored alongside the Sri Yantra.",
    points: [
      "Complete Sri Vidhya foundation",
      "Different lineages explored",
      "Sri Suktam · Lalita Sahasranam",
      "Khadgamala Stotram · Sri Yantra",
    ],
  },
  {
    id: "astrology",
    title: "Predictive Ancient Astrology",
    duration: "4.5 Months",
    price: "Enquire",
    exclusive: false,
    img: "/course-astrology.jpg",
    desc:
      "Taught by an expert co-mentor with years of experience. We bust the myths, learn accurate predictive methods from basics to advanced, and back-test formulas on real charts, with case studies and assignments.",
    points: [
      "Basics to advanced predictive methods",
      "Backtesting & testing of formulas",
      "Marriage, relationships, longevity, profession",
      "Travel, property, education, death, Prashna Jyotish",
      "Case studies & assignments",
    ],
  },
  {
    id: "healing",
    title: "Reiki Healing — Self & Others",
    duration: "1.5 Months",
    price: "Enquire",
    exclusive: false,
    img: "/course-healing.jpg",
    desc:
      "Learn Reiki to heal yourself and others over 1.5 months. A gentle, practical journey in energy healing to restore balance, release blocks and hold healing space for those around you.",
    points: [
      "Reiki self-healing practices",
      "Healing others with intention",
      "Energy balancing techniques",
    ],
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Choose Your Focus",
    desc: "Select career, relationship, marriage, life transition, or the next 2–3 months.",
  },
  {
    n: "02",
    title: "Share Your Situation",
    desc: "Tell me your questions and current concerns over a short, private message.",
  },
  {
    n: "03",
    title: "Receive Guidance",
    desc: "A personalised astrology and tarot-based consultation with practical reflection.",
  },
  {
    n: "04",
    title: "Leave With Next Steps",
    desc: "Walk away grounded, with clarity and a clear direction to focus on next.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I came in anxious about a career shift and left with a calm, clear sense of direction. Shreya's guidance felt both spiritual and deeply practical.",
    name: "Aarohi M.",
    role: "Bengaluru",
    rating: 5,
  },
  {
    quote:
      "The tarot reading explained patterns I'd struggled with for years. It was gentle, honest and genuinely healing.",
    name: "Rohan K.",
    role: "Mumbai",
    rating: 5,
  },
  {
    quote:
      "My Reiki session melted away months of stress. I felt lighter and more myself than I had in a very long time.",
    name: "Neha S.",
    role: "Delhi",
    rating: 5,
  },
  {
    quote:
      "The Tarot course changed how I trust my own intuition. Shreya teaches with so much patience and depth.",
    name: "Ishita P.",
    role: "Pune",
    rating: 5,
  },
  {
    quote:
      "Learning Sri Vidhya with her has been the most grounding part of my spiritual journey. Truly life-changing.",
    name: "Karan D.",
    role: "Jaipur",
    rating: 5,
  },
];

// Instagram grid — @healingbysri. TODO(Shreya): swap with your real post images.
export const INSTAGRAM = [
  "/ig-lalita.jpg",
  "/course-shrividhya.jpg",
  "/offering-healing.jpg",
  "/guidance-tarot.jpg",
  "/hero-immersion.jpg",
  "/about-shreya.jpg",
];

export const FAQS = [
  {
    q: "Do I need to prepare anything for a session?",
    a: "Not at all. You do not need to have everything figured out before booking. Come with your questions, your current situation, and an open mind.",
  },
  {
    q: "Are the sessions online or in person?",
    a: "Most sessions are conducted online over video call so you can join comfortably from anywhere. In-person sessions can be arranged on request.",
  },
  {
    q: "Is everything I share kept private?",
    a: "Absolutely. Every session is completely confidential. Your story, questions and readings stay between us.",
  },
  {
    q: "How do I book a session?",
    a: "Simply reach out over WhatsApp or email. We'll find a time that works, and I'll guide you through the rest.",
  },
];

export const MARQUEE = [
  "Astrology",
  "Tarot",
  "Spiritual Guidance",
  "Reiki",
  "Meditation",
  "Inner Healing",
];

export const IMAGES = {
  hero: "/hero-immersion.jpg?v=2",
  portrait: "/about-shreya.jpg",
  altar:
    "https://images.pexels.com/photos/29775672/pexels-photo-29775672.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  lotus:
    "https://images.unsplash.com/photo-1474557157379-8aa74a6ef541?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};
